export const ERROR_MESSAGES: Record<string, string> = {
  name: 'Please add your name',
  email: 'Enter your email',
  giftAmount: 'Enter the amount you will gift',
}
